export const COLORS = {
	Primary: "#0A4997",
	Secondary: "#00A4E3",
	Default: "#66C1D7",
	Grey: "#BBC4C2",
	LightGrey: "#F3F4F6",
	LightGrey2: "#E8EAED",
	LightGrey3: "#cbcdd0",
	MediumGrey: "#99a19f",
	DarkGrey: "#4f4f4f",
	White: "#ffffff",
	Black: "#000000",
	NearBlack: "#171717",
	Danger: "#ff4d4f",
	Warning: "#faad14",
	Success: "#52c41a",
	LightGreen: "#86EFAC",
	StrongGreen: "#4ADE80",
	SkeletonGrey: "#bebebe33",
	LightDefault: "#ebfbff",
	Brown: "#ad7402",
	Purple: "#df40f7",
	Violet: "#88649c",
	VioletBlue: "#4338ca",
	LightSuccess: "#dcfae4",
	LightSecondary: "#d4f1fc",
	LightPrimary: "#91bff8",
	ChartColors: [
		"#0A4997",
		"#00A4E3",
		"#52c41a",
		"#4ADE80",
		"#ff4d4f",
		"#ad7402",
		"#faad14",
		"#88649c",
		"#df40f7",
		"#BBC4C2",
	],
	LightDanger: "#fecfd0",
	LightWarning: "#fbeac9",
};

export default COLORS;
